import { AlcolockEventGroup } from "@components/tacho/alcolockCompliance/alcolock.enums";


export enum RecipientType {
    Group,
    User,
    Custom
}

export enum RecipientDeliveryType { // named RecipientType on back-end
    Email = 0,
    Sms = 1
}

export enum NotificationStatus {
    Pending = 0,
    Processing = 1,
    Processed = 2
}

export enum ApplicationType {
    Bifrost = 0,
    Valkyrie = 1,
    Host = 2,
    Intranet = 3,
    QueueReader = 4,
    Tests = 5,
    Default = 6,
    Chronos = 7,
    DevApps = 8,
    Heimdall = 9,
    DeviceSimulator = 10,
    Sif = 11
}

export enum ResourceType {
    Account = 0,
    Contact = 1,
    Deal = 2,
    Job = 3,
    JobBooking = 4,
    Package = 5,
    Peripheral = 6,
    Product = 7,
    ProductGroup = 8,
    Sim = 9,
    Site = 10,
    Unit = 11,
    Vehicle = 12,
    Ticket = 13,
    Stock = 14,
    Engineer = 15,
    SoftwareLog = 16,
    Driver = 17,
    Trailer = 18,
    VerilocationUser = 19,
    Announcement = 20,
    Plot = 21,
    User = 22,
    DriverDecisionSupport = 23,
    GeocodedAddress = 24,
    Geofence = 25,
    Group = 26,
    Journey = 27,
    Message = 28,
    OutboundQueue = 29,
    RfidData = 30,
    DigiDl = 31,
    AlertRecord = 32,
    ReportSchedule = 33,
    Log = 34,
    Test = 35,
    MaintenanceType = 36,
    StirlingJob = 37,
    DigiDlPacket = 38,
    EngineeringJob = 39
}

export enum AlertState {
    Raised = 0,
    Cleared = 1
}

export enum AlertCategory {
    Geofence = 0,
    Vehicle = 1,
    //Telematics = 2,
    //Temperature = 3, // Deprecated
    //Tms = 4, // Deprecated
    Toll = 5,
    Alcolock = 6,
    Tyres = 7,
    Inputs = 8,
    FaultCode = 9,
    Tachograph = 10,
    TemperatureProfile = 11,
    Transcan = 12,
    CameraEvent = 13,
    Zone = 14,
    AxleWeightProfile = 15,
    PowerEvent = 16
}

export enum VehicleAlertSubCategory {
    //DrivingWithoutTachoCard = 0, // Deprecated
    Speeding = 1,
    ContextualSpeeding = 2,
    FuelLevelChange = 3,
    ExcessiveDwell = 4,
    DrivingWithoutDriverAssigned = 5,
    PlotReason = 6
}

export enum TollAlertSubCategory {
    Enter,
    Exit
}

export enum GeofenceAndZoneAlertSubCategory {
    Enter,
    Exit,
}


export enum TyreAlertSubCategory {
    SystemError,
    PressureAlarm,
    TemperatureAlarm,
    PressureWarning,
    TemperatureWarning,
}

export enum FaultCodeAlertSubCategory {
    Alert
}

export enum TachoAlertSubCategory {
    Warning,
    Infringement,
    DrivingWithoutTachoCard
}

export enum TranscanAlertSubCategory {
    Alarm
}

export enum InputAlertSubCategory {
    On,
    Off,
}

export enum TemperatureProfileAlertSubCategory {
    OutOfBounds,
    InBounds
}

export enum ResourceFilterType {
    Any,
    Group,
    Specific,
    None
}

export enum TriggerValueOperator {
    Equals = 0,
    LessThan = 1,
    GreaterThan = 2
}

export enum AlcolockAlertSubCategory {
    Circumvention = AlcolockEventGroup.Circumvention,
    Diagnostics = AlcolockEventGroup.SignificantEvent,
    Fail = AlcolockEventGroup.Fail,
    Pass = AlcolockEventGroup.Pass
}


// If we update this, we need to also check that the enum value also exists in Common
// VideoEntryNotificationCategories.ValidVideoEventCodes

export enum VideoEventSubCategory {
    //Unknown = -1,
    Button = 0,
    //Speed = 1,
    Acceleration = 2,
    //LowShock = 3,
    //MediumShock = 4,
    HighShock = 5,
    Braking = 6,
    Turning = 7,
    //UserRequested = 8,
    //Sensor = 9,
    //Exception = 10,
    //Motion = 11,
    //PowerOff = 12,
    DriverFatigue = 13,
    DriverOnPhone = 14,
    DriverSmoking = 15,
    DriverDistraction = 16,
    DriverAbsent = 17,
    Pedestrian = 18,
    Collision = 19,
    LaneDeparture = 20,
    VehicleTooClose = 21,
    DriverLogin = 22,
    BlindSpot = 23,
    NoSeatBelt = 24,
    CameraCovered = 26,
}

export enum AlertPreferenceType {

    DistanceMeasurement = 1,
    VolumeMeasurement = 2,
    TemperatureMeasurement = 3,
    Currency = 4,
    Language = 5,
    Timezone = 6
}

export enum AxleWeightProfileAlertSubCategory {
    OutOfBounds,
    InBounds
}

export enum PowerEventAlertSubCategory {
    Lost, Restored
}
